(ns ui.page-components.toolbar.view
    (:require [ui.util :as uu]))

(defn toolbar
  [{:keys [left center right class style]
    :or   {left   nil
           center nil
           right  nil
           class  ""
           style  {}}}]
  [:div
   {:class (uu/cm
             "w-full"
             "flex items-center"
             "gap-3"
             "px-3 py-2"
             "border-b border-solid border-base-light-border-paler"
             "bg-base-light"
             class)
    :style style}

   ;; Left: natural width, sticks to left
   [:div
    {:class (uu/cm "flex items-center gap-2 min-w-0 justify-start")}
    left]

   ;; Center: centered in the whole toolbar (not just between left & right)
   ;; We use an absolutely centered container; pointer events disabled on wrapper,
   ;; enabled on the inner container so buttons are clickable.
   [:div
    {:class (uu/cm "relative flex-0")}
    [:div
     {:class (uu/cm "absolute left-1/2 -translate-x-1/2"
                    "flex items-center gap-2"
                    "pointer-events-none")}
     [:div {:class "pointer-events-auto"} center]]]

   ;; Right: natural width, sticks to right
   [:div
    {:class (uu/cm "ml-auto flex items-center gap-2 min-w-0 justify-end")}
    right]])
